import React from 'react'
import { TextFieldDisplayType } from '@deal/components'
import { NumericPathFlowQuestionDisplayType } from '#src/generated/graphql'
import { NumericPathFlowQuestionDefinition } from '#src/components/Path/Question'
import Number from './Number'
import Height from './Height'
// import Range from './Range'
import StarRating from './StarRating'

export interface NumericPathFlowQuestionProps
  extends NumericPathFlowQuestionDefinition<CustomProps> {
  value?: number | null
}

interface CustomProps {
  display?: TextFieldDisplayType
}

class NumericPathFlowQuestion extends React.PureComponent<
  NumericPathFlowQuestionDefinition<CustomProps>
> {
  public componentDidMount() {
    if (!this.props.question.required) {
      this.props.onFieldValidityChanged(true)
    }
  }

  public render() {
    const { question, ...rest } = this.props
    const deriveComponentType = (displayType?: NumericPathFlowQuestionDisplayType | null) => {
      switch (displayType) {
        case NumericPathFlowQuestionDisplayType.HEIGHT_IN_INCHES:
          return Height
        case NumericPathFlowQuestionDisplayType.STAR_RATING:
          return StarRating
        // TODO: Add Range question here
        default:
          return Number
      }
    }

    const NumberComponent = deriveComponentType(question.displayType)

    const value: number | null | undefined = question.numericUserInput
      ? question.numericUserInput.value
      : null

    return <NumberComponent value={value} question={question} {...rest} />
  }
}

export default NumericPathFlowQuestion
